import lpApp from '../lp_app';
import { lpIdGetPure } from '../../logic/global_getter';

/*
 * Project: LegalPlace assistant
 * File: src/app/ops/two_steps.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/


class LpTwoSteps {
  checkOption(idx) {
    return lpApp.references.two_steps.ts_options[lpIdGetPure(idx)]
        && lpApp.references.two_steps.ts_options[lpIdGetPure(idx)].value
        && !lpApp.isPayed;
  }


  checkVariable(idx) {
    return lpApp.references.two_steps.ts_variables[lpIdGetPure(idx)]
        && lpApp.references.two_steps.ts_variables[lpIdGetPure(idx)].value
        && !lpApp.isPayed;
  }

  checkSection(idx) {
    return lpApp.references.two_steps.ts_sections[lpIdGetPure(idx)]
        && lpApp.references.two_steps.ts_sections[lpIdGetPure(idx)].value
        && !lpApp.isPayed;
  }

  isDiscovered(idx, type = 'option') {
    switch (type) {
      case 'option':
        if (lpApp.references.two_steps.ts_options[idx]) {
          return lpApp.references.two_steps.ts_options[idx].isDiscovered();
        }
        return true;
      case 'variable':
        if (lpApp.references.two_steps.ts_variables[idx]) {
          return lpApp.references.two_steps.ts_variables[idx].isDiscovered();
        }
        return true;
      case 'section':
        if (lpApp.references.two_steps.ts_sections[idx]) {
          return lpApp.references.two_steps.ts_sections[idx].isDiscovered();
        }
        return true;
      default:
        return true;
    }
  }
}

export default LpTwoSteps;



// WEBPACK FOOTER //
// ./src/app/ops/two_steps.js